import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./list-item.module.css";
export const ListItem = ({ label , href , ariaLabel , handleClickEvent , apiData  })=>/*#__PURE__*/ _jsx("a", {
        href: href,
        "aria-label": ariaLabel,
        className: styles.listItem,
        onClick: handleClickEvent,
        children: `${label} ${apiData ? `(${apiData})` : ""}`
    });
